import dynamic from "next/dynamic";
import { useState } from "react";
import DrawerContainer from "containers/drawer/drawer";
import { useAuth } from "contexts/auth/auth.context";
import { useMediaQuery } from "@mui/material";

const Wallet = dynamic(() => import("components/wallet/wallet"));
const TopUpWallet = dynamic(() => import("components/topUpWallet/topUpWallet"));
const SendWallet = dynamic(() => import("components/sendWallet/sendWallet"));

export default function WalletContainer() {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const { walletHistoryOpen, closeWalletHistory } = useAuth();

  const [currentView, setCurrentView] = useState<"wallet" | "topUp" | "send">(
    "wallet",
  );

  const renderView = () => {
    switch (currentView) {
      case "wallet":
        return <Wallet changeView={setCurrentView} />;

      case "topUp":
        return <TopUpWallet changeView={() => setCurrentView("wallet")} />;

      case "send":
        return <SendWallet changeView={() => setCurrentView("wallet")} />;

      default:
        return <Wallet changeView={setCurrentView} />;
    }
  };

  return (
    <DrawerContainer
      open={walletHistoryOpen}
      onClose={closeWalletHistory}
      PaperProps={{
        style: {
          minWidth: isDesktop ? "500px" : "100%",
        },
      }}
    >
      {renderView()}
    </DrawerContainer>
  );
}
